module.exports = __webpack_public_path__ + "fonts/Open_Sans-300-vietnamese9.738d367.woff2";